<div>
    <label>Active/Inactive</label>
    <div class="row sortByRadioButtons">
        <div class="radio ascendingRadioButton">
            <input class="" type="radio" :name="componentId + '-activeInactiveRadio'" :id="componentId + '-radioActive'" :value="activeIsActiveKey.active" 
                    v-model="activeOrInactiveSelectedKey" 
                    @change="onActiveOrInactiveSelect">
            <label class="" :for="componentId + '-radioActive'">
                Active
            </label>
        </div>
        <div class="radio">
            <input class="" type="radio" :name="componentId + '-activeInactiveRadio'" :id="componentId + '-radioInactive'" :value="activeIsActiveKey.inactive" 
                    v-model="activeOrInactiveSelectedKey"
                    @change="onActiveOrInactiveSelect">
            <label class="" :for="componentId + '-radioInactive'">
                Inactive
            </label>
        </div>
    </div>
</div>